import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { it } from 'date-fns/locale';
import mixpanel from 'mixpanel-browser';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'react-toastify/dist/ReactToastify.css';

import MaterialTheme from './MaterialTheme';
import config from './config/config';
import { logMixPanelEvent } from './services/tracking/mixPanel';
import { Router } from './Router';
import { BrowserRouter } from 'react-router-dom';
import { UpdateAvailableButton } from './components';

const queryClient = new QueryClient();

// init mixpanel
const { mixpanelId, mixpanelDebug } = config;
mixpanel.init(mixpanelId, { debug: mixpanelDebug });

export function App() {
  useEffect(() => {
    document.title = config.appTitle;
    console.log('Version', config.appVersion);
    logMixPanelEvent('user login');
  }, []);

  return (
    <>
      <GoogleOAuthProvider clientId={config.googleLoginClientId}>
        <QueryClientProvider client={queryClient}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
            <MaterialTheme>
              <BrowserRouter>
                <Router />
              </BrowserRouter>
            </MaterialTheme>
          </LocalizationProvider>
        </QueryClientProvider>
      </GoogleOAuthProvider>
      <ToastContainer position="top-right" />
      <UpdateAvailableButton />
    </>
  );
}

export default App;
